import { render } from "./BackupInfo.vue?vue&type=template&id=692b5a62"
import script from "./BackupInfo.vue?vue&type=script&lang=js"
export * from "./BackupInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Documents/mybackup/backup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__